import { computed } from 'mobx';

export default class ParameterTypeModel {
  id;
  store;

  constructor(store, parameterType) {
    this.store = store;
    this.updateFromJson(parameterType);
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      parameter_unit_id: this.parameter_unit_id,
      unit_name: this.unit_name,
      unit_symbol: this.unit_symbol,
      parameters: this.parameters,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.parameter_unit_id = json.unit_id;
    this.unit_name = json.unit_name;
    this.unit_symbol = json.unit_symbol;
    this.parameters = json.parameters ? json.parameters.map(parameter => (
      this.store.parameterStore.resolveItem({ ...parameter, parameter_type_id: +json.id })
    )) : this.parameters;
  }
}



// WEBPACK FOOTER //
// ./src/models/ParameterTypeModel.js